export enum InvoiceStatus {
  Pending = "pending",
  Paid = "paid",
  Overdue = "overdue",
  PartiallyPaid = "partially_paid",
  Cancelled = "cancelled",
  Refunded = "refunded",
}
